import type { DomainError } from '@core/domain';

import { MessageToast } from '../../../../core/components/MessageToast';

interface ErrorToastsProps {
  /** Delete operation errors */
  deleteErrorToast?: string | null;
  /** Skip operation errors */
  skipErrors: DomainError[];
  /** Callback to clear delete error toast */
  onClearDeleteError: () => void;
}

/**
 * ErrorToasts component for displaying operation errors in the audit decision panel
 * Handles both delete and skip operation error display with proper error keys
 */
export function ErrorToasts({ deleteErrorToast, skipErrors, onClearDeleteError }: ErrorToastsProps) {
  return (
    <>
      {/* Error Toast for Delete Operations */}
      {deleteErrorToast && <MessageToast message={deleteErrorToast} variant="error" onClose={onClearDeleteError} />}

      {/* Error Toasts for Skip Operations */}
      {skipErrors.map(error => {
        const errorKey = `skip-${error.code}-${error.correlationId || 'no-correlation'}`;

        return (
          <MessageToast
            key={errorKey}
            isVisible
            ariaLabel={`Skip operation error: ${error.userMessage}`}
            message={error.userMessage}
            subMessage={`Error Code: ${error.code}${error.correlationId ? `\nCorrelation ID: ${error.correlationId}` : ''}`}
            variant="error"
            onClose={() => {
              // Skip errors are managed by the hook, so we don't need to clear them manually
              // They will be cleared when a new operation starts
            }}
          />
        );
      })}
    </>
  );
}
